import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { trans, getPagePath } from '@spotahome/soyuz/client';

import { Button, Input, CheckboxWithLabel } from '@spotahome/ui-library';

import SectionHeading from '../../../common/components/SectionHeading';

import './Form.scss';

import {
  FORM_BIG_SIZE_INPUT,
  FORM_SMALL_SIZE_CHECKBOX,
  FORM_FULL_WIDTH_INPUT,
  FORM_TYPE_TEXT_INPUT,
  FORM_TYPE_EMAIL_INPUT
} from '../common/constants';

const Form = props => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [terms, setTerms] = useState(false);

  const toggleTerms = () => setTerms(prevTerms => !prevTerms);

  const handleSubmit = event => {
    event.preventDefault();
    props.onFormSubmission({ firstName, lastName, email, terms });
  };

  const renderTermsAndConditionsLink = () => {
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        className="form__link"
        href={getPagePath('externals.referrals-terms-and-conditions')}
      >
        {trans('external.refer_a_friend.terms_and_conditions')}
      </a>
    );
  };

  return (
    <div className="form__wrapper">
      <SectionHeading
        text={trans('external.refer_a_friend.form.title')}
        theme="dark"
        type="none"
      />
      <form className="form" onSubmit={handleSubmit}>
        {/* eslint-disable-next-line jsx-a11y/label-has-for */}
        <label className="form__label" htmlFor="nameInput">
          {trans('external.refer_a_friend.form.input.label.name')}
          <Input
            className="form__input"
            size={FORM_BIG_SIZE_INPUT}
            width={FORM_FULL_WIDTH_INPUT}
            type={FORM_TYPE_TEXT_INPUT}
            value={firstName}
            onChange={event => setFirstName(event.target.value)}
            placeholder={trans('external.refer_a_friend.form.input.name')}
            name="nameInput"
            dataTest="ext-referral-form-input-name"
          />
        </label>
        {/* eslint-disable-next-line jsx-a11y/label-has-for */}
        <label className="form__label" htmlFor="lastNameInput">
          {trans('external.refer_a_friend.form.input.label.lastName')}
          <Input
            className="form__input"
            size={FORM_BIG_SIZE_INPUT}
            width={FORM_FULL_WIDTH_INPUT}
            type={FORM_TYPE_TEXT_INPUT}
            value={lastName}
            onChange={event => setLastName(event.target.value)}
            placeholder={trans('external.refer_a_friend.form.input.lastName')}
            name="lastNameInput"
          />
        </label>
        {/* eslint-disable-next-line jsx-a11y/label-has-for */}
        <label className="form__label" htmlFor="emailInput">
          {trans('external.refer_a_friend.form.input.label.email')}
          <Input
            className="form__input"
            size={FORM_BIG_SIZE_INPUT}
            width={FORM_FULL_WIDTH_INPUT}
            type={FORM_TYPE_EMAIL_INPUT}
            value={email}
            onChange={event => setEmail(event.target.value)}
            placeholder={trans('external.refer_a_friend.form.input.email')}
            required
            name="emailInput"
            pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-z]{2,24}$"
            dataTest="ext-referral-form-input-email"
          />
        </label>
        <CheckboxWithLabel
          value={terms}
          // eslint-disable-next-line react/jsx-handler-names
          callback={toggleTerms}
          text={renderTermsAndConditionsLink()}
          className="form__checkbox"
          size={FORM_SMALL_SIZE_CHECKBOX}
          checked={terms}
          required
          dataTest="ext-referral-form-checkbox"
        />
        <Button
          className="form__btn"
          type="submit"
          data-test="ext-referral-form-btn"
          size="big"
        >
          {trans('external.refer_a_friend.form.input.submit')}
        </Button>
      </form>
    </div>
  );
};

Form.propTypes = {
  onFormSubmission: PropTypes.func.isRequired
};

export default Form;
